import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {I18nSupportedLocale} from '../constants';

export const getAvailableLocales = () => {
	const localesPref = getPreference('i18n.userSelectableLocales');
	if (!localesPref) return Object.values(I18nSupportedLocale);
	const localesFilter = localesPref.split(/[ ,]+/);
	return Object.values(I18nSupportedLocale).filter((locale) =>
		localesFilter.includes(locale),
	);
};

export default getAvailableLocales;
